
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import encabezado from './lista-listado-encabezado.vue';
    import jexcel from 'jexcel';
    import jQuery from 'jquery';
    import 'jexcel/dist/jexcel.css';
    import Vuetify from 'vuetify';
    import vuetify from '@/__env/pluggins/vuetify';
   

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;



        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            //this.Eventos.push( this.Controlador.onRecargar.subscribe( () =>{this.Refrescar();            } ) );
            this.Iniciar();
        }

        public Celdas: Vue[] = [];
        public SpreadSheet: any = null;
        async Iniciar()
        {
            let columnas: any[] = [];
            let nestedHeaders: any[] = [];
            for ( var i = 0; i < this.Controlador.Archivo.encabezados.length; i++ )
            {
                let col = this.Controlador.Archivo.encabezados[i];
                columnas.push( { type: 'text', title: i.toString() } );
                nestedHeaders.push( { title: col, colspan: 1 } );
            }
            var options = {
                allowToolbar: false,
                columnSorting: false,
                columnDrag: false,
                columnResize: true,
                rowResize: false,
                rowDrag: false,
                allowManualInsertRow: false,
                allowInsertColumn: false,
                allowManualInsertColumn: false,
                allowDeleteColumn: false,
                allowDeleteRow: true,
                selectionCopy: false,
                search: false,
                minDimensions: [0, 1],
                tableOverflow: true,
                tableWidth: "100vw",
                defaultColWidth: 250,

                //onfocus: () => this.Focused = true,
                //onblur: () => this.Focused = false,
                onchange: this.TableOnChange,
                //onbeforechange: this.TableOnChange,
                //onselection: this.TableOnSelection,
                columns: columnas,
                nestedHeaders: nestedHeaders,
            };

            let spreadsheet = jexcel( document.getElementById( 'tabla-importar' ), options );
            this.SpreadSheet = spreadsheet;
            Object.assign( this, { spreadsheet } );

            this.SpreadSheet.hideIndex();

            Vue.use( Vuetify );
            for ( var i = 0; i < this.Controlador.Archivo.encabezados.length; i++ )
            {
                let col = this.Controlador.Archivo.encabezados[i];
                let em = document.querySelector( `td[data-x="${i}"][title="${i}"]` );
                if ( em )
                {
                    let celda1 = Vue.extend( encabezado );
                    let vm1 = new celda1( { propsData: { Controlador: this.Controlador, Titulo: col, Posicion: i, Item: null }, vuetify: vuetify } ).$mount();

                    em.innerHTML = '';
                    em.appendChild( vm1.$el );
                }


            }

            for ( var f = 0; f < this.Controlador.Archivo.columnas.length; f++ )
            {
                let fila = this.Controlador.Archivo.columnas[f];
                if ( f != 0 )
                {
                    this.SpreadSheet.insertRow( [], this.Controlador.Archivo.encabezados.length );
                }
                for ( var i = 0; i < fila.length; i++ )
                {
                    let col = fila[i];
                    this.SpreadSheet.setValueFromCoords( i, f, col, true );
                }
            }
            //this.SpreadSheet.deleteRow( this.Controlador.Archivo.columnas.length, 1 );

            this.Cargado = true;
        }

        public Cargado: boolean = false;
        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        TableOnChange( instance: string, cell: HTMLTableCellElement, x: string, y: string, value: string ): any
        {
            if ( this.Cargado )
            {
                this.Controlador.Archivo.columnas = this.SpreadSheet.getData();
                this.Controlador.RecargarPreset();
            }

        }
    }
